import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const guideLinesStyles: IStyles = {
    guides: {
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 50,
    },
    guideV: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: 1,
        background: color.critical500,
        pointerEvents: 'none',
    },
    guideH: {
        position: 'absolute',
        left: 0,
        right: 0,
        height: 1,
        background: color.critical500,
        pointerEvents: 'none',
    },
}

addStyles(guideLinesStyles)
export default guideLinesStyles
